import React, { useEffect, useState } from 'react';
import {
  Box,
  InputBase,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  useTheme,
  InputAdornment,
  InputLabel,
  Grid,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LayoutImageManager from './Popups/LayoutImageManager';
import { useSelector } from 'react-redux';
import { KeyboardArrowDown } from '@mui/icons-material';

const TAG_OPTIONS = ['Free', 'Issue', 'Purchase', 'Exhaustible', 'NonExhaustible', 'InLabOnly', 'HighValue'];

const SearchBar = ({
  activeTab,
  searchQuery,
  setSearchQuery,
  category,
  setCategory,
  group,
  setGroup,
  tag,
  setTag,
  status,
  setStatus,
  supervised,
  setSupervised,
}) => {
  const categoryListGlobal = useSelector(state => state.category.category_list) || [];
  const groupListGlobal = useSelector(state => state.group.group_list) || [];

  const categories = categoryListGlobal.map(c => c.name);
  const groups = groupListGlobal.map(g => g.name);
  const tags = TAG_OPTIONS;

  // Reset filters when the activeTab changes
  useEffect(() => {
    setCategory('');
    setGroup('');
    setTag('');
    setStatus('All');
    setSupervised('All');
  }, [activeTab, setCategory, setGroup, setTag, setStatus, setSupervised]);

  const handleSearchChange = event => {
    setSearchQuery(event.target.value);
  };

  const handleCategoryChange = value => {
    setCategory(category === value ? '' : value);
  };

  const handleGroupChange = (value) => {
    if (group === value) {
      setGroup('');
    } else {
      setGroup(value);
    }
  };

  const handleTagChange = (value) => {
    if (tag === value) {
      setTag('');
    } else {
      setTag(value);
    }
  };

  const statusOptions = [
    { label: 'All', value: 'All' },
    { label: 'Operational', value: '0' },
    { label: 'Under Maintenance', value: '1' },
    { label: 'Out of Order', value: '2' },
  ];

  const supervisedOptions = [
    { label: 'All', value: 'All' },
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ];

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const theme = useTheme();

  return (
    <Box
      component="form"
      onKeyDown={handleKeyDown}
      sx={{
        width: '100%',
        mt: 2,
        padding: theme.spacing(2),
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* CATEGORY */}
        <Grid item xs={12} sm={2.5} md={2}>
          <FormControl fullWidth>
            <InputLabel>Categories</InputLabel>
            <Select
              value={category}
              // onChange={handleCategoryChange}
              // multiple
              label="Categories"
              IconComponent={KeyboardArrowDown}
              disabled={categories?.length === 0}
              sx={{ height: 48, textAlign: 'left' }}
            >
              {categories.map(name => (
                <MenuItem key={name} value={name} onClick={() => handleCategoryChange(name)}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* STATUS */}
        {(activeTab === 0 || activeTab === 1 || activeTab === 2) && (
          <Grid item xs={6} sm={2} md={1.5}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                label="Status"
                onChange={(e) => setStatus(e.target.value)}
                IconComponent={KeyboardArrowDown}
                sx={{ height: 48, textAlign: 'left' }}
              >
                {statusOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* SUPERVISED */}
        {(activeTab === 0 || activeTab === 1 || activeTab === 2) && (
          <Grid item xs={6} sm={2} md={1.5}>
            <FormControl fullWidth>
              <InputLabel>Supervised</InputLabel>
              <Select
                value={supervised}
                label="Supervised"
                onChange={(e) => setSupervised(e.target.value)}
                IconComponent={KeyboardArrowDown}
                sx={{ height: 48, textAlign: 'left' }}
              >
                {supervisedOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* GROUP (Inventory Only) */}
        {activeTab === 2 && (
          <Grid item xs={6} sm={2} md={1.5}>
            <FormControl fullWidth>
              <InputLabel>Group</InputLabel>
              <Select
                value={group}
                label="Group"
                IconComponent={KeyboardArrowDown}
                disabled={groups?.length === 0}
                sx={{ height: 48, textAlign: 'left' }}
              >
                {groups.map(grp => (
                  <MenuItem key={grp} value={grp} onClick={() => handleGroupChange(grp)}>
                    {grp}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* TAGS (Inventory Only) */}
        {activeTab === 2 && (
          <Grid item xs={6} sm={2} md={1.5}>
            <FormControl fullWidth>
              <InputLabel>Tags</InputLabel>
              <Select
                value={tag}
                label="Tags"
                IconComponent={KeyboardArrowDown}
                disabled={tags?.length === 0}
                sx={{ height: 48, textAlign: 'left' }}
              >
                {tags.map(tg => (
                  <MenuItem key={tg} value={tg} onClick={() => handleTagChange(tg)}>
                    {tg}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* SEARCH */}
        <Grid item xs={12} sm={3} md={3} ml="auto">
          <InputBase
            placeholder="Search…"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{
              width: '100%',
              height: 48,
              border: '1px solid #E6E6E6',
              borderRadius: '10px',
              bgcolor: '#FAFAFA',
              px: 1,
            }}
            startAdornment={
              <InputAdornment position="start">
                <IconButton size="small">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>

        {activeTab === 3 && (
          <Grid item xs={12}>
            <LayoutImageManager />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default SearchBar;
